/* eslint-disable no-undef */

import { phoneFormatter } from 'merchant/services/Helper.service';

// @ts-nocheck
let commonAnalyticsData;
const createBody = (data?) => {
  return {
    Tag: 'GoKwik',
    // Products: commonAnalyticsData?.products,
    Currency: commonAnalyticsData?.currency,
    'Promo Code': commonAnalyticsData?.coupon || '',
    'Cart Total Price': commonAnalyticsData?.cart_after_discount,
    ...data,
  };
};

export const callGrowlytics = (eventName, data) => {
  data.commonAnalyticsData && (commonAnalyticsData = data.commonAnalyticsData);
  if (eventName === 'phoneNumber') {
    growlyticsMobileGK(data);
  } else if (eventName === 'pinCode') {
    growlyticsPinCode(data);
  } else if (eventName === 'paymentMethod') {
    growlyticsPaymentMethod(data);
  } else if (eventName === 'paymentCompleted') {
    growlyticsPaymentCompletedGK(data);
  } else if (eventName === 'paymentCompletedNeemans') {
    growlyticsPaymentCompleted(data);
  } else if (eventName === 'userAddress') {
    growlyticsUserAddress(data);
  }
};

const growlyticsMobileGK = (data) => {
  let credentials = {
    eventName: 'Mobile_Added_GK',
    data: createBody({
      'Mobile Number': '+91' + data.evt.phoneNumber,
      'Abandoned URL': data.abcURL,
      ABC_sms: data.abcURL + `&ch=growlytics&src=sms`,
      ABC_mail: data.abcURL + `&ch=growlytics&src=mail`,
      ABC_wa: data.abcURL + `&ch=growlytics&src=wa`,
      ABC_limechat: data.abcURL + `&ch=growlytics&src=limechat`,
      ABC_zoko: data.abcURL + `&ch=growlytics&src=zoko`,
      ABC_gupshup: data.abcURL + `&ch=growlytics&src=guphsup`,
    }),
    'Product Name': data.commonAnalyticsData.product_name_array,
    'Product ID': data.commonAnalyticsData.pidArr,
    'Product Quantity': data.commonAnalyticsData.products.map((a) => a['Product Quantity']),
    'Product Variant ID': data.commonAnalyticsData.products.map((a) => a['Product Variant Id']),
    'Product Price': data.commonAnalyticsData.products.map((a) => a['Product Price']),
    Currency: data.commonAnalyticsData.currency,
    'Image URL': data.commonAnalyticsData.imgUrlArr,
    'Product Url': data.commonAnalyticsData.products.map((a) => a['Product Url']),
    'Promo Code': data?.commonAnalyticsData.coupon,
    'Cart Total Price': data.commonAnalyticsData.cart_total_price,
  };

  Growlytics.events.track(credentials.eventName, { ...credentials.data });
};

const growlyticsPinCode = (data) => {
  let credentials = {
    analyticsName: 'growlytics',
    eventName: 'PIN_Code_Added_GK',
    data: createBody({
      Pincode: '' + data.evt.pincode,
    }),
  };

  Growlytics.events.track(credentials.eventName, { ...credentials.data });
};

const growlyticsPaymentMethod = (data) => {
  let credentials = {
    eventName: 'Payment_Method_Selected_GK',
    data: createBody({
      'Mobile Number': '+91' + data.phoneNumber,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Full Address': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Pincode: +data.userAddress?.pincode,
      'Address Type': data.userAddress?.addresstype,
      'Shipping Method': data.shippingMethod || 'Standard',
      'Payment method': data.evt.paymentMethod,
      'Promo Code': data?.commonAnalyticsData.coupon,
    }),
  };

  Growlytics.events.track(credentials.eventName, { ...credentials.data });
};

const growlyticsPaymentCompleted = (data) => {
  let credentials = {
    eventName: 'Checkout Ended',
    data: {
      Phone: '+91' + data.phoneNumber,
      'Product Ids': data.commonAnalyticsData.products,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      Address: data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Pincode: +data.userAddress?.pincode,
      'Address Type': data.userAddress?.addresstype,
      'Promo Code': data?.commonAnalyticsData.coupon || '',
      'Shipping Method': data.shippingMethod || 'Standard',
      'Payment Mode': data.paymentMethod,
      'Total Price': data.commonAnalyticsData.cart_after_discount,
      'Payment Complete': data.evt.paymentComplete,
      Tag: 'GoKwik',
      'Shipping Charge': Number(data.shippingCharge),
      'Transaction Status': 'successful',
      'Transaction Id': null,
      'Discount code applied': !!commonAnalyticsData.coupon,
      'Products Name': data.commonAnalyticsData.product_name_array,
      'Subtotal Price': data.commonAnalyticsData.cart_after_discount,
      'Total Quantity': data.commonAnalyticsData.total_quantity,
      'Cart Details': data.cart.items,
      Products: data.commonAnalyticsData.product_name_array.join(','),
    },
  };

  Growlytics.events.track(credentials.eventName, { ...credentials.data });
};

const growlyticsPaymentCompletedGK = (data) => {
  if (data?.analyticsPixelObj?.growlytics?.value === 'phone') {
    growlytics.user.login(phoneFormatter(data.phoneNumber, data.analyticsPixelObj?.growlytics));
  } else if (data?.analyticsPixelObj?.growlytics?.value === 'email') {
    growlytics.user.login(data.userAddress?.email?.toLowerCase());
  } else {
    growlytics.user.login(shopifyCustomerId);
  }
  let credentials = {
    eventName: 'Payment_Complete_GK',
    data: createBody({
      'Mobile Number': '+91' + data.phoneNumber,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Full Address': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Pincode: +data.userAddress?.pincode,
      'Address Type': data.userAddress?.addresstype,
      'Shipping Method': data.shippingMethod || 'Standard',
      'Payment method': data.paymentMethod,
      'Payment Complete': data.evt.paymentComplete,
      'Products Name': data.commonAnalyticsData.product_name_array.join(','),
    }),
  };
  Growlytics.events.track(credentials.eventName, { ...credentials.data });
};

const growlyticsUserAddress = (data) => {
  let credentials = {
    eventName: data.eventName,
    data: createBody({
      'First Name': data.evt.userAddress.firstname,
      'Last Name': data.evt.userAddress.lastname,
      Email: data.evt.userAddress.email,
      'Full Address': data.evt.userAddress.address,
      City: data.evt.userAddress.city,
      State: data.evt.userAddress.state,
      /* Address selected - string
			Add added - number */
      Pincode:
        data.eventName === 'Address_Selected_GK' ? '' + data.evt.userAddress.pincode : +data.evt.userAddress.pincode,
      'Address Type': data.evt.userAddress.addresstype,
      'Shipping Method': data.shippingMethod || 'Standard',
      'Abandoned URL': `${location.origin}?mrid=${commonAnalyticsData.request_id}`,
      ABC_sms: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=growlytics&src=sms`,
      ABC_mail: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=growlytics&src=mail`,
      ABC_wa: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=growlytics&src=wa`,
      ABC_limechat: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=growlytics&src=limechat`,
      ABC_zoko: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=growlytics&src=zoko`,
      ABC_gupshup: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=growlytics&src=gupshup`,
      'Mobile Number': `+91${data.phoneNumber}`,
    }),
  };
  Growlytics.events.track(credentials.eventName, { ...credentials.data });
  Growlytics.user.identify(credentials.data.Email, {
    name: `${credentials.data['First Name']} ${credentials.data['Last Name']}`,
    email: credentials.data.Email,
    mobile: credentials.data['Mobile Number'],
  });
};
